import * as fns from "duration-fns";
import { formatTime } from "/lib/mathsExtension.js";
import { playlistIds } from "/lib/publicEnv.js";

import Image from 'next/image';

import Tilt from "react-parallax-tilt";

export default function Thumbnail(props) {
    let videoType = "Kooleyy";
    if (props.playlistId === playlistIds.teamVideos) {
        videoType = "Team";
    };
    if (props.playlistId === playlistIds.bestVideos) {
        videoType = "Best";
    };

    const duration = formatTime(fns.toSeconds(props.duration));

    return (
        <div className="transform hover:scale-105 block group relative w-full bg-transparent transition-all ease-in-out duration-300 rounded-2xl overflow-hidden">             
            <div className="flex flex-col w-full gap-y-4 h-full px-6 pr-12 py-4 pb-12 animate-pulse min-w-[300px] md:min-w-[400px] max-w-[600px] min-h-[150px] bg-gray-900 rounded-xl">
            </div>
        </div>
    );
};